__turbopack_context__.v({
  "even": "GradientTypography-module-scss-module__wh-dKG__even",
  "gradient-glow-blue": "GradientTypography-module-scss-module__wh-dKG__gradient-glow-blue",
  "gradient-glow-neon": "GradientTypography-module-scss-module__wh-dKG__gradient-glow-neon",
  "gradient-glow-orange": "GradientTypography-module-scss-module__wh-dKG__gradient-glow-orange",
  "gradient-glow-pink": "GradientTypography-module-scss-module__wh-dKG__gradient-glow-pink",
  "gradient-glow-snap-pea": "GradientTypography-module-scss-module__wh-dKG__gradient-glow-snap-pea",
  "gradient-neon-pink": "GradientTypography-module-scss-module__wh-dKG__gradient-neon-pink",
  "gradient-pink-blue": "GradientTypography-module-scss-module__wh-dKG__gradient-pink-blue",
  "gradient-pink-orange": "GradientTypography-module-scss-module__wh-dKG__gradient-pink-orange",
  "line": "GradientTypography-module-scss-module__wh-dKG__line",
  "odd": "GradientTypography-module-scss-module__wh-dKG__odd",
  "seo-text": "GradientTypography-module-scss-module__wh-dKG__seo-text",
  "title": "GradientTypography-module-scss-module__wh-dKG__title",
});
